module.exports = __webpack_public_path__ + "img/bracers_12.da4bdd75.png";